import {
  ICompanyToolsCategory,
  ICompanyToolsCategoryCreate,
  ICompanyToolsCategoryUpdate,
} from '../../resource/company-tools-category/company-tools-category.types';
import { IApiRequestConfig } from '../api.types';

export const searchCompanyToolsCategoriesApi = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getCompanyToolsCategories',
  uri: 'json',
  action: 'company-tools-categories',
  method: 'get',
  v2: true,
});

export const createCompanyToolsCategoryApi = (
  companyToolsCategory: ICompanyToolsCategoryCreate,
): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'createCompanyToolsCategory',
  uri: 'json',
  action: 'company-tools-categories',
  method: 'post',
  data: companyToolsCategory,
  v2: true,
});

export const updateCompanyToolsCategoryApi = (
  companyToolsCategory: ICompanyToolsCategoryUpdate,
): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'updateCompanyToolsCategory',
  uri: 'json',
  action: `company-tools-categories/${companyToolsCategory.id}`,
  method: 'patch',
  data: companyToolsCategory,
  v2: true,
});

export const deleteCompanyToolsCategoryApi = (
  companyToolsCategoryId: ICompanyToolsCategory['id'],
): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'deleteCompanyToolsCategory',
  uri: 'json',
  action: `company-tools-categories/${companyToolsCategoryId}`,
  method: 'delete',
  v2: true,
});
